import { render, staticRenderFns } from "./mitra-kurir-motor.vue?vue&type=template&id=32073ced&scoped=true"
import script from "./mitra-kurir-motor.vue?vue&type=script&lang=js"
export * from "./mitra-kurir-motor.vue?vue&type=script&lang=js"
import style0 from "./mitra-kurir-motor.vue?vue&type=style&index=0&id=32073ced&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32073ced",
  null
  
)

export default component.exports